// extracted by mini-css-extract-plugin
export default {"container":"Product_container__WBSTT","products":"Product_products__KUcea","menu":"Product_menu__TXGn+","list":"Product_list__RG03b","product":"Product_product__xEc6X"};